import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Col,Row } from "react-bootstrap";

import UserForm from "../../features/User/UserForm"
import UserList from "../../features/User/UserList"
import { UserConstants } from "../../features/User/user.types";
import { userService } from "../../features/User/userAPI";
import { useLoader } from "../../context/LoaderContext";
import { fetchUsers, setSites } from "../../features/User/userSlice";
import { AppDispatch, RootState } from "../../store/store";

const ManageLogoPortalUser: React.FC = () => {
    const loginUserData = useSelector((state: RootState) => state.users.loginUser);
    const siteMetaData = useSelector((state: RootState) => state.users.sites);
    const userState = useSelector((state: RootState) => state.users);
    const { setLoading } = useLoader();
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if(siteMetaData.length == 0){
           getCustomerSites();
        }else{
           fetchUser(); 
        }
    }, []);

    /**
     *  Fetch account users
     */
    const fetchUser = async () => {
        try {
            setLoading(true);
            await dispatch(fetchUsers(loginUserData)).unwrap();
            setLoading(false);
        } catch (error: any) {
            console.log(error);
            setLoading(false);
            const errorMessage = error?.response?.data?.message || UserConstants.ERROR_FETCH_USER;
            toast.error(errorMessage);
        }
    };


    /**
    * Get all sites
    */
    const getCustomerSites = async () => {
        try {
            setLoading(true);
            const customerSites = await userService.fetchCustomerSites();
            if (customerSites?.length > 0) {
                dispatch(setSites(customerSites));
            }
            setLoading(false);
            fetchUser();
        } catch (error: any) {
            console.log(error);
            setLoading(false);
            const errorMessage = error?.response?.data?.message || UserConstants.ERROR_FETCH_USER;
            toast.error(errorMessage);
        }
    }


    return (
        <main className="container-fluid dashboard-bg">
            <div className="main main-app p-3 p-lg-4">
                <div className="min-vh-100 h-sm-auto d-flex">
                    <div className="p-4 w-100 bg-light">
                        <Row className="py-2">
                            <Col className="d-flex justify-content-between align-items-center">
                                <div className="fs-32">Manage Logo Portal Users</div>
                            </Col>
                        </Row>
                        <UserForm/>
                        <UserList />
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ManageLogoPortalUser;